import type { SVGProps } from 'react';

export const SvgIconArrowRight = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 17" fill="none" {...props}>
    <path d="M6 3.2998L11 8.2998L6 13.2998" stroke="#888888" strokeWidth="1.5" strokeLinejoin="round" />
  </svg>
);
